import { trace } from 'rytm-helpers'
import Dialog from './../models/Dialog'

/**
 * Kontroler do okien dialogowych
 */
class DialogController {
  /**
  * DialogController class constructor  
  * @constructor
  **/
  constructor() {
    this.dialogs = []
  }
  destroy() {
    // todo close all dialogs
    this.dialogs.forEach((d) => {
      d.destroy()
    })
    this.dialogs = []
  }
  /**
   * Open DIALOG
   * @param {String} id 
   * @param {Object} params 
   */
  dialogOpen(id, params) {
    let d = this.getDialog(id, params)
    if (!d) {
      d = new Dialog(id, params)
      this.addDialog(d)
    }
    d.open()
  }
  /**
   * Close DIALOG
   * @param {String} id {dialog: el, toggleBtn: btn}
   */
  dialogClose(id) {
    const d = this.getDialog(id)
    if (!d) {
      trace("Missing dialog:", id)
      return
    }
    this.removeDialog(id)
  }
  /**
   * Close All dialogs
   */
  dialogCloseAll() {
    const list = this.getAllOpened()
    list.forEach((d) => {
      this.dialogClose(d.id)
    })
  }
  /**
   * Add dialog
   * @param {Dialog} dialog 
   */
  addDialog(dialog) {
    this.removeDialog(dialog.id)
    this.dialogs.push(dialog)
  }
  /**
   * Remove dialog
   * @param {String} id 
   */
  removeDialog(id) {
    const dialog = this.getDialog(id)
    if (dialog) {
      dialog.destroy()
      let arr = []
      this.dialogs.forEach((d) => {
        if (d.id !== id) {
          arr.push(d)
        }
      })
      this.dialogs = arr
    }
  }
  /**
   * ###############
   * ### HELPERS ###
   */
  getAllOpened() {
    let arr = []
    this.dialogs.forEach((d) => {
      if (d.expanded == true) {
        arr.push(d)
      }
    })
    return arr
  }
  getLastOpened() {
    let result = false
    const list = this.getAllOpened()
    if (list.length > 0) {
      result = list[list.length - 1]
    }
    return result
  }
  getDialog(id) {
    let result = false
    this.dialogs.forEach((d) => {
      if (d.id == id) {
        result = d
        return result
      }
    })
    return result
  }
  

}

export default DialogController